export default __webpack_public_path__ + "static/media/Vecna Robotics.bead2c23.png";